module.exports = __webpack_public_path__ + "assets/media/day34.c5d5250d.mp3";